// extracted by mini-css-extract-plugin
module.exports = {"commentWidgetWrappper":"jWBah","commentIcon":"Z0kUm"};